export default "__VITE_ASSET__DNyu8R$Q__"